import React from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import "./bdrCopyIcon.css";

/**
 * BdrCopyIcon — the "this copies" affordance (2026-10-09).
 *
 * Three glyphs stacked in ONE fixed box: the resting icon (a phone, a pin), a
 * copy glyph, and a check. Hovering or keyboard-focusing the nearest
 * `.bdr-copy-host` crossfades resting → copy, so the action announces itself
 * without waiting on a tooltip; `copied` shows the check for a moment after.
 * Only opacity and scale move, so nothing around it shifts.
 *
 * Presentational: the HOST owns the click, the clipboard write, the snackbar
 * and the `copied` timer. Put `bdr-copy-host` on the element whose hover
 * should trigger the swap — the button itself, or a whole row (the client
 * rail puts it on the row AND on its copy button, so a row hover and a
 * keyboard focus on the button both swap).
 *
 * First consumers: ClientFactRow (client rail) and the Available Sooner rows.
 */
const BdrCopyIcon = ({ icon, copied = false, className = "" }) => (
  <span
    className={`bdr-copy-icon${copied ? " is-copied" : ""} ${className}`.trim()}
    aria-hidden="true"
  >
    <span className="bdr-copy-glyph bdr-copy-glyph--base">{icon}</span>
    <span className="bdr-copy-glyph bdr-copy-glyph--copy">
      <ContentCopyIcon fontSize="small" />
    </span>
    <span className="bdr-copy-glyph bdr-copy-glyph--done">
      <CheckIcon fontSize="small" />
    </span>
  </span>
);

export default BdrCopyIcon;
